'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.doesNotContainHtml = undefined;

var _general = require('./general');

/**
 * Validate a string does not contain HTML tags
 * @param value
 * @returns {boolean}
 */
var doesNotContainHtml = exports.doesNotContainHtml = function doesNotContainHtml(value) {
  return !value || !(0, _general.makeMatchesRegex)(/<[a-z][\s\S]*>/i)(value);
};